(ns web3.screens.pro.offer
  (:require [web3.view :as v]
            [web3.i18n :as i]
            [web3.routing.core :as routing]
            [web3.env :as env]
            [web3.screens.pro.utils :as pro]
            [web3.view.hiccup :as hiccup]
            [web3.icons.shapes :as shapes]))

(v/defview upgrade-offer []
  [:div.pre-wrap
   pro/icon-flag
   [:div.text-size-20.weight-medium.line-h-24
    (i/to-do "Are you a Real Estate or\nService Professional?")]
   [:div.weight-medium.text-dark-gray.text-size-16.margin-top-3
    (i/to-do (str "Calling all realtors, mortgage brokers, builders, general contractors, plumbers, electricians, painters, lock smiths, "
                  "and other real estate and service professionals.\n\nSign up for a free Pro Account to access advanced "
                  (:partner/name env/config) " features that will help you grow your business and be remembered by your clients."))]
   [:a.flex.items-center.margin-top-2 {:href (routing/path-for [:pro/offer])}
    (i/get :i/learn-more)
    (-> shapes/chevron-right
        (hiccup/size 12))]])